import React from 'react'
import { Detail } from '../types'
import { groupAndFilterComplexDetails, useComplexDetail } from '../hooks/complexDetail'

export type ParcelDetailType = "zoning" | "municipality" | "zipcode" | "councilDistrict" | "soilType"

interface ComplexParcelDetailsProps {
  details: Detail[] | undefined
  PIN: number
  type: ParcelDetailType
}

const ComplexParcelDetails: React.FC<ComplexParcelDetailsProps> = ({ details, PIN, type }) => {
  if (!details) return <i className='fa fa-spinner fa-spin pull-right'></i>;
  const filteredDetailGroups = groupAndFilterComplexDetails(details)

  const detailComponents = filteredDetailGroups.map((detailGroup, i) => (
    <ComplexParcelDetail details={detailGroup} PIN={PIN} type={type} key={i} />
  ));

  return <>{detailComponents}</>;
};

interface ComplexParcelDetailProps {
  details: Detail[]
  PIN: number
  type: ParcelDetailType
}

const ComplexParcelDetail: React.FC<ComplexParcelDetailProps> = ({ details, PIN, type }) => {
  const { isActive, toggleDetail, addHoverHighlight, removeHoverHighlight } = useComplexDetail(details, PIN, type)

  return (
    <>
      <input className="off-the-grid"
        id={details[0].label}
        name="parcel-details"
        type="checkbox"
        onChange={toggleDetail}
        checked={isActive}
      />
      <label htmlFor={details[0].label} className="sub-details" onMouseEnter={addHoverHighlight} onMouseLeave={removeHoverHighlight}>
        {details[0].label}
      </label>
    </>
  )
}

export default ComplexParcelDetails;